<template>
  <v-expansion-panels v-model="detail_panel" multiple>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div>
          <v-icon>mdi-truck</v-icon><span class="headerTitle">{{ labels.cargoRiskDetTitle }}</span>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="vslDetList"
                    v-model="mainForm.vesNo"
                    :label="labels.vesNo"
                    item-text="label"
                    item-value="value"
                    data-vv-name="vesNo"
                    :data-vv-as="labels.vesNo"
                    :error-messages="errors.collect('vesNo')"
                    :loading="loading"
                    @input="doVesNo"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.vesName"
                    :label="labels.vesName"
                    :error-messages="errors.collect('vesName')"
                    data-vv-name="vesName"
                    :data-vv-as="labels.vesName"
                    v-validate="'required|max:80'"
                    @input="doVesName"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-dialog v-model="autoCreateVesselVoyageDialog" width="1280px" :disabled="mainForm.vesNo === undefined ? true : false">
                    <v-btn color="primary" flat>
                      {{ labels.autoCreateVesselVoyage }}
                    </v-btn>
                    <vessel-voyage
                      @close="autoCreateVesselVoyageDialog = false"
                      :vesNo="mainForm.vesNo"
                      :vesName="mainForm.vesName"
                      @loadVesNo="doVesNo"
                    ></vessel-voyage>
                  </v-dialog>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="vslVoyList"
                    v-model="mainForm.voyNo"
                    :label="labels.voyNo"
                    item-text="label"
                    item-value="value"
                    data-vv-name="voyNo"
                    :data-vv-as="labels.voyNo"
                    :error-messages="errors.collect('voyNo')"
                    :loading="vslVoyLoading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="crgoVoyDateList"
                    v-model="mainForm.voyDateType"
                    :label="labels.voyDateType"
                    item-text="label"
                    item-value="value"
                    data-vv-name="voyDateType"
                    :data-vv-as="labels.voyDateType"
                    :error-messages="errors.collect('voyDateType')"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <cal-picker
                    v-model="mainForm.voyDate"
                    :label="labels.voyDate"
                    v-validate="voyDateValidation"
                    :data-vv-as="labels.voyDate"
                    data-vv-name="voyDate"
                    :error-messages="errors.collect('voyDate')"
                    :hint="getVoyDateHint(mainForm.voyDate)"
                    :persistent-hint="true"
                    :class="getVoyDateClass()"
                  ></cal-picker>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="crgoVoyList"
                    v-model="mainForm.voyArea"
                    :label="labels.voyArea"
                    item-text="label"
                    item-value="value"
                    data-vv-name="voyArea"
                    :data-vv-as="labels.voyArea"
                    :error-messages="errors.collect('voyArea')"
                    @input="doVoyArea"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="crgoPortList"
                    v-model="mainForm.portDep"
                    :label="labels.portDep"
                    item-text="label"
                    item-value="value"
                    data-vv-name="portDep"
                    :data-vv-as="labels.portDep"
                    :error-messages="errors.collect('portDep')"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="crgoPortList"
                    v-model="mainForm.portArr"
                    :label="labels.portArr"
                    item-text="label"
                    item-value="value"
                    data-vv-name="portArr"
                    :data-vv-as="labels.portArr"
                    :error-messages="errors.collect('portArr')"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg8 xs12>
                  <v-textarea
                    v-model="mainForm.voyDesc"
                    :label="labels.voyDesc"
                    :error-messages="errors.collect('voyDesc')"
                    v-validate="'max:100|entry'"
                    data-vv-validate-on="change"
                    data-vv-name="voyDesc"
                    :data-vv-as="labels.voyDesc"
                    :rows="2"
                  ></v-textarea>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="coverList"
                    v-model="mainForm.coverage"
                    :label="labels.coverage"
                    item-text="label"
                    item-value="value"
                    data-vv-name="coverage"
                    :data-vv-as="labels.coverage"
                    :error-messages="errors.collect('coverage')"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="crgoComdtyList"
                    v-model="mainForm.comdtyType"
                    :label="labels.comdtyType"
                    item-text="label"
                    item-value="value"
                    data-vv-name="comdtyType"
                    :data-vv-as="labels.comdtyType"
                    :error-messages="errors.collect('comdtyType')"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="crgoPackList"
                    v-model="mainForm.pkgType"
                    :label="labels.pkgType"
                    item-text="label"
                    item-value="value"
                    data-vv-name="pkgType"
                    :data-vv-as="labels.pkgType"
                    :error-messages="errors.collect('pkgType')"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12> </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="surAgentList"
                    v-model="mainForm.surAgt"
                    :label="labels.surAgt"
                    item-text="label"
                    item-value="value"
                    data-vv-name="surAgt"
                    :data-vv-as="labels.surAgt"
                    :error-messages="errors.collect('surAgt')"
                    v-validate="'required'"
                    @input="doSurAgt"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg8 xs12>
                  <v-textarea v-model="surAgtDet" :rows="4" readonly :loading="loading"></v-textarea>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="setAgentList"
                    v-model="mainForm.setAgt"
                    :label="labels.setAgt"
                    item-text="label"
                    item-value="value"
                    data-vv-name="setAgt"
                    :data-vv-as="labels.setAgt"
                    :error-messages="errors.collect('setAgt')"
                    v-validate="'required'"
                    @input="doSetAgt"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg8 xs12>
                  <v-textarea v-model="setAgtDet" :rows="4" readonly :loading="loading"></v-textarea>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="certBordList"
                    v-model="mainForm.certBord"
                    :label="labels.certBord"
                    item-text="label"
                    item-value="value"
                    data-vv-name="certBord"
                    :data-vv-as="labels.certBord"
                    :error-messages="errors.collect('certBord')"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.dclrCertNo"
                    :label="labels.dclrCertNo"
                    :error-messages="errors.collect('dclrCertNo')"
                    data-vv-name="dclrCertNo"
                    :data-vv-as="labels.dclrCertNo"
                    v-validate="dclrCertNoValidation"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import VesselVoyage from '@/components/core/common/dialog/VesselVoyage'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { POLICY_GENERAL } from '@/store/types'
import clone from 'clone'
import { isEqual } from '@/utils/compare'
// import { formatDisplayTime } from '@/utils/date'
export default {
  data() {
    return {
      labels: {
        cargoRiskDetTitle: 'Marine Cargo Risk Details',
        vesNo: 'Vessel No.',
        vesName: 'Vessel Name',
        autoCreateVesselVoyage: 'Auto Create Vessel Voyage',
        voyNo: 'Voyage No',
        voyDateType: 'Voyage Date Type',
        voyDate: 'Voyage Date',
        voyArea: 'Voyage Area Code',
        portDep: 'Voyage From',
        portArr: 'Voyage To',
        voyDesc: 'Voyage Description',
        coverage: 'Coverage Code',
        comdtyType: 'Commodity Code',
        pkgType: 'Packing Type',
        surAgt: 'Survey Agent',
        setAgt: 'Settlement Agent',
        certBord: 'Cert/Bordereaux',
        dclrCertNo: 'Declared Certificate No.',
        vesVoyDets: 'Vessel Voyage Detail',
        exit: 'Exit',
        save: 'Save'
      },
      mainForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        vesNo: undefined,
        vesName: undefined,
        voyNo: undefined,
        voyDateType: undefined,
        voyDate: undefined,
        voyArea: undefined,
        portDep: undefined,
        portArr: undefined,
        voyDesc: undefined,
        coverage: undefined,
        comdtyType: undefined,
        pkgType: undefined,
        surAgt: undefined,
        setAgt: undefined,
        certBord: undefined,
        dclrCertNo: undefined
      },
      vesVoyForm: {
        vesNo: undefined,
        vesName: undefined,
        voyDet: undefined,
        estDeptDate: undefined
      },
      generalForm: {
        polNo: undefined,
        renCnt: 0,
        endtCnt: 0,
        tranDate: undefined,
        acceptDate: undefined,
        acceptTime: undefined,
        acct1DocNo: undefined,
        acct1TranType1: undefined,
        acct2DocNo: undefined,
        acct2TranType1: undefined,
        acct3DocNo: undefined,
        acct3TranType1: undefined,
        acctNo1: undefined,
        acctNo2: undefined,
        acctNo3: undefined,
        agent: undefined,
        acctYr: 0,
        acctMth: 0,
        appCoins: false,
        billCoIns: undefined,
        coInsPct: 0,
        appRiskTax: 0,
        appShortTerm: 0,
        batchRel: 0,
        billCurr: undefined,
        billCurrRate: 0,
        branch: undefined,
        busSrc: undefined,
        cedAnt: undefined,
        acctNoSfx: undefined,
        cedPolNo: undefined,
        cedCesNo: undefined,
        cedSI: 0,
        ourSharePct: 0,
        cnType: undefined,
        cnNo: undefined,
        cnDate: undefined,
        comDate: undefined,
        comm1: 0,
        comm2: 0,
        comm3: 0,
        cty: undefined,
        dept: undefined,
        disc: 0,
        dRi: false,
        endtDate: undefined,
        endtSeqNo: undefined,
        entDate: undefined,
        entUsrId: 0,
        expDate: undefined,
        finInst: undefined,
        firstIssDate: undefined,
        fund: undefined,
        genPolNo: false,
        gstStatPrem: undefined,
        gstStatComm1: undefined,
        gstStatComm2: undefined,
        gstStatComm3: undefined,
        gstRatePrem: 0,
        gstRateComm1: 0,
        gstRateComm2: 0,
        gstRateComm3: 0,
        gstAEPrem: false,
        gstAEComm1: false,
        gstAEComm2: false,
        gstAEComm3: false,
        gstPrem: 0,
        gstComm1: 0,
        gstComm2: 0,
        gstComm3: 0,
        gstStatRateAEPrem: false,
        gstStatRateAEComm1: false,
        gstStatRateAEComm2: false,
        gstStatRateAEComm3: false,
        issDate: undefined,
        noCIPrt: 0,
        noDrCrPrt: 0,
        noTaxInvPrt: 0,
        noRiApplnPrt: 0,
        noSchedPrt: 0,
        occupation: undefined,
        moCmpNo: undefined,
        paytMeth: undefined,
        polEndtTxt: undefined,
        polFee: 0,
        polLwrTxt: undefined,
        polMemo: undefined,
        polPd: 0,
        polGap: 0,
        polRenTxt: undefined,
        polStamp: 0,
        polStat: undefined,
        polTax: 0,
        polType: undefined,
        polUppTxt: undefined,
        prevInsr: undefined,
        progId: undefined,
        prtCILn: false,
        prtDrCrLn: false,
        prtRiApplnLn: false,
        prtSchedLn: false,
        rcptNo: undefined,
        recip: undefined,
        redBal1: false,
        redBal2: false,
        redBal3: false,
        relDate: undefined,
        relUsrId: undefined,
        renPolNo: undefined,
        riskFee: 0,
        riskStamp: 0,
        riskTax: 0,
        prevPolNo: undefined,
        prevPolExpDate: undefined,
        renSeqNo: undefined,
        retroDate: undefined,
        riFac: false,
        schedForm: undefined,
        schedPremHead: undefined,
        scheme: undefined,
        promotion: undefined,
        securGrp: undefined,
        termDate: undefined,
        totNoInstal: 0,
        tranRel: false,
        tranType: undefined,
        uwYr: 0,
        endtType: undefined,
        dateRenPrt: undefined,
        discLdg1: 0,
        discLdg2: 0,
        discLdg3: 0,
        endtForm: undefined,
        prtDiscLdg1: false,
        prtDiscLdg2: false,
        prtDiscLdg3: false,
        redBalDiscLdg2: false,
        redBalDiscLdg3: false,
        cpId: undefined,
        cpBrn: undefined,
        schedPrt: false,
        drCrPrt: false,
        riLvl: undefined,
        discCommLvl: undefined,
        insdRefNo: undefined,
        titleName: undefined,
        insdName1: undefined,
        insdName2: undefined,
        insdName3: undefined,
        insdAddr1: undefined,
        insdAddr2: undefined,
        insdAddr3: undefined,
        insdAddr4: undefined,
        postCode: undefined,
        icNo: undefined,
        telNo1: undefined,
        telNo2: undefined,
        mobile: undefined,
        fax: undefined,
        email: undefined,
        drCrNo: false,
        modDate: undefined,
        modUsrId: 0,
        grpPol: false,
        grpNamedPol: false,
        empCont: false,
        depdCont: false,
        stdBenRate: false,
        prtSchedInsd: false,
        prtSchedBen: false,
        prtSchedPrem: false,
        execIC: undefined,
        coRiPct: 0,
        maintPer: 0,
        prtInsdDr: false,
        industry: undefined,
        insBondNo: undefined,
        totNoWrkmen: 0,
        paiExpDate: undefined,
        medPolNo: undefined,
        cedAcctNoSfx: undefined,
        dliabPer: 0,
        tpBill: false,
        phCltGrp: undefined,
        isPhGstReg: false,
        gstRegNo: undefined,
        gstRegDate: undefined,
        polStampAE: false,
        polFeeAE: false,
        polTaxAE: false,
        prtSubTaxInv: false,
        premWar: undefined,
        convEntUsrId: undefined,
        convRelUsrId: undefined,
        brkSlipNo: undefined,
        brkTranRef: undefined,
        prtVarDesc: undefined,
        acctNo2Sfx: undefined,
        acctNo3Sfx: undefined,
        agentAcctNoSfx: undefined,
        discLdg1Code: undefined,
        discLdg2Code: undefined,
        discLdg3Code: undefined,
        insdName4: undefined,
        moCmpUpld: false,
        recHash: undefined,
        prtTaxInvLn: false,
        nxtBillMth: 0,
        billType: undefined,
        contractExpDate: undefined,
        cpCode: undefined,
        ccaDate: undefined,
        ccdDate: undefined,
        insdRefNoAE: false,
        insdStat: undefined,
        nationality: undefined,
        icNoROC: undefined,
        altName1: undefined,
        altName2: undefined,
        sameInsdAddr: false,
        altInsdAddr1: undefined,
        altInsdAddr2: undefined,
        altInsdAddr3: undefined,
        altInsdAddr4: undefined,
        altPostCode: undefined,
        agtUsrId: 0,
        DOB: undefined,
        gender: undefined,
        normOnRel: false,
        endtCode: undefined,
        cancelCode: undefined,
        entRilater: false,
        ipcStatus: undefined,
        ipcNo: undefined,
        ipcDate: undefined,
        ourShareSI: 0,
        campaign: undefined,
        riApplnPrt: false,
        ciPrt: false,
        ipcSeqNo: undefined,
        certBord: undefined,
        createdBy: undefined,
        createdDate: undefined,
        modifiedBy: undefined,
        modifiedDate: undefined,
        revision: 0
      },
      loading: false,
      vslVoyLoading: false,
      vslDetList: [],
      vslVoyList: [],
      crgoVoyDateList: [],
      voyDateWarning: false,
      startUWYr: undefined,
      crgoVoyList: [],
      crgoPortList: [],
      coverList: [],
      crgoComdtyList: [],
      crgoPackList: [],
      surAgentList: [],
      setAgentList: [],
      surAgtDet: undefined,
      setAgtDet: undefined,
      certBordList: [
        { label: 'C - Individual Certificate', value: 'C' },
        { label: 'B - Bordereaux', value: 'B' }
      ],
      autoCreateVesselVoyageDialog: false,
      vesVoyDetsLoading: false,
      detail_panel: []
    }
  },
  props: {
    polRisk: Object
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    getVslDet() {
      return this.vslDetList.filter((vslDet) => {
        return vslDet.value === this.mainForm.vesNo
      })
    },
    getVslNo() {
      return this.vslDetList.filter((vslDet) => {
        return vslDet.secondaryValue.data.vesName === this.mainForm.vesName
      })
    },
    voyDateValidation() {
      if (this.startUWYr && this.mainForm.voyDate) {
        var mainFormDateValue = new Date(this.mainForm.voyDate)
        var voydatemonth = this.parseStrformat(parseInt(mainFormDateValue.getMonth()) + 1)
        var voydateday = this.parseStrformat(parseInt(mainFormDateValue.getDate()))
        var cUWYR = voydatemonth + '' + voydateday
        var polmasterUwyr = parseInt(this.polMaster.uwYr)
        var voydateYr = parseInt(mainFormDateValue.getFullYear().toString())
        var startUWYr = parseInt(this.startUWYr)
        if (this.add1Uwyr === true) {
          polmasterUwyr = parseInt(polmasterUwyr) - 1
        }
        return 'VoyageDate_Validate:' + voydateYr + ',' + polmasterUwyr + ',' + cUWYR + ',' + startUWYr + '|' +
        'VoyageDate_Validate2:' + voydateYr + ',' + polmasterUwyr + ',' + cUWYR + ',' + startUWYr
        // if (this.startUWYr.toString().length === 4) {
        //   var d = new Date()
        //   var iMonth = parseInt(this.startUWYr.toString().substring(0, 2)) - 1
        //   var iDay = parseInt(this.startUWYr.toString().substring(2, 4))
        //   d.setFullYear(this.polMaster.uwYr, iMonth, iDay)
        //   return 'VoyageDate_Validate:' + voydateYr + ',' + polmasterUwyr + ',' + cUWYR + ',' + startUWYr + '|' +
        // 'VoyageDate_Validate2:' + voydateYr + ',' + polmasterUwyr + ',' + cUWYR + ',' + startUWYr + '|' + 'start_enddate:' + d
        // } else if (this.startUWYr.toString().length === 3) {
        //   d = new Date()
        //   iMonth = parseInt(this.startUWYr.toString().substring(0, 1)) - 1
        //   iDay = parseInt(this.startUWYr.toString().substring(1, 3))
        //   d.setFullYear(this.polMaster.uwYr, iMonth, iDay)
        //   return 'VoyageDate_Validate:' + voydateYr + ',' + polmasterUwyr + ',' + cUWYR + ',' + startUWYr + '|' +
        // 'VoyageDate_Validate2:' + voydateYr + ',' + polmasterUwyr + ',' + cUWYR + ',' + startUWYr + '|' + 'start_enddate:' + d
        // }
      }
      return ''
    },
    getCrgoVoy() {
      return this.crgoVoyList.filter((crgoVoy) => {
        return crgoVoy.value === this.mainForm.voyArea
      })
    },
    getSurAgt() {
      return this.surAgentList.filter((surAgent) => {
        return surAgent.value === this.mainForm.surAgt
      })
    },
    getSetAgt() {
      return this.setAgentList.filter((setAgent) => {
        return setAgent.value === this.mainForm.setAgt
      })
    },
    dclrCertNoValidation() {
      if (this.mainForm.certBord === 'C' && this.mainForm.dclrCertNo !== '') {
        return 'required_blank'
      } else {
        return ''
      }
    }
  },
  methods: {
    doInit() {
      this.getPolCargoRisk().then(() => {
        this.getCargoParams().then(() => {
          this.getVslVoyList()
          this.doSetAgt()
          this.doSurAgt()
        })
      })
    },
    async getPolCargoRisk() {
      const apiUrl = this.$store.state.underwriting.policyCargoRiskSettings.menu.getPolCargoRisk
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.polRisk.riskGrpNo,
            riskNo: this.polRisk.riskNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.polCargoRisk) {
            this.mainForm.polNo = result.data.polCargoRisk.data.polNo
            this.mainForm.renCnt = result.data.polCargoRisk.data.renCnt
            this.mainForm.endtCnt = result.data.polCargoRisk.data.endtCnt
            this.mainForm.riskGrpNo = result.data.polCargoRisk.data.riskGrpNo
            this.mainForm.riskNo = result.data.polCargoRisk.data.riskNo
            this.mainForm.vesNo = result.data.polCargoRisk.data.vesNo
            this.mainForm.vesName = result.data.polCargoRisk.data.vesName
            this.mainForm.voyNo = result.data.polCargoRisk.data.voyNo
            this.mainForm.voyDateType = result.data.polCargoRisk.data.voyDateType
            this.mainForm.voyDate = result.data.polCargoRisk.data.voyDate
            this.mainForm.voyArea = result.data.polCargoRisk.data.voyArea
            this.mainForm.portDep = result.data.polCargoRisk.data.portDep
            this.mainForm.portArr = result.data.polCargoRisk.data.portArr
            this.mainForm.voyDesc = result.data.polCargoRisk.data.voyDesc
            this.mainForm.coverage = result.data.polCargoRisk.data.coverage
            this.mainForm.comdtyType = result.data.polCargoRisk.data.comdtyType
            this.mainForm.pkgType = result.data.polCargoRisk.data.pkgType
            this.mainForm.surAgt = result.data.polCargoRisk.data.surAgt
            this.mainForm.setAgt = result.data.polCargoRisk.data.setAgt
            this.mainForm.certBord = result.data.polCargoRisk.data.certBord
            this.mainForm.dclrCertNo = result.data.polCargoRisk.data.dclrCertNo
          }
          this.hideInitLoading()
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
        this.copymainForm = clone(this.mainForm)
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    hideInitLoading() {
      // Set parent policy.initLoading to false
      this.$emit('hide-init-loading')
    },
    async getCargoParams() {
      const apiUrl = this.$store.state.underwriting.policyCargoRiskSettings.menu.getCargoParams
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            busCls: this.polRisk.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            this.$set(this, 'vslDetList', result.data.vslDetList)
            this.$set(this, 'crgoVoyDateList', result.data.crgoVoyDateList)
            this.startUWYr = result.data.startUwyr
            this.add1Uwyr = result.data.add1Uwyr
            this.$set(this, 'crgoVoyList', result.data.crgoVoyList)
            this.$set(this, 'crgoPortList', result.data.crgoPortList)
            this.$set(this, 'coverList', result.data.coverList)
            this.$set(this, 'crgoComdtyList', result.data.crgoComdtyList)
            this.$set(this, 'crgoPackList', result.data.crgoPackList)
            this.$set(this, 'surAgentList', result.data.surAgentList)
            this.$set(this, 'setAgentList', result.data.setAgentList)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doVesNo() {
      if (this.getVslDet.length > 0) {
        this.mainForm.vesName = this.getVslDet[0].secondaryValue.data.vesName
        this.getVslVoyList()
      } else {
        this.mainForm.vesName = ''
      }
    },
    doVesName() {
      if (this.getVslNo.length > 0) {
        this.mainForm.vesNo = this.getVslNo[0].value
        this.getVslVoyList()
      }
    },
    async getVslVoyList() {
      if (this.mainForm.vesNo !== undefined) {
        const apiUrl = this.$store.state.underwriting.policyCargoRiskSettings.menu.getVslVoyList
        if (apiUrl) {
          try {
            this.vslVoyLoading = true
            const expand = {
              vesNo: this.mainForm.vesNo
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))

            if (result.data) {
              this.$set(this, 'vslVoyList', result.data.vslVoyList)
            }
            this.vslVoyLoading = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    getVoyDateHint(voyDate) {
      if (voyDate === undefined || voyDate === null || voyDate === '') {
        this.voyDateWarning = true
        return "WARNING: Blank Date will print 'To be Advised' on schedule"
      } else {
        this.voyDateWarning = false
        return ''
      }
    },
    getVoyDateClass() {
      if (this.voyDateWarning) {
        return 'voyDateWarning'
      } else {
        return ''
      }
    },
    doVoyArea() {
      if (this.getCrgoVoy.length > 0) {
        this.mainForm.voyDesc = this.getCrgoVoy[0].label
      }
    },
    doSurAgt() {
      if (this.getSurAgt.length > 0) {
        var surAgtInfo = this.getSurAgt[0].secondaryValue.data.name
        if (
          this.getSurAgt[0].secondaryValue.data.address1 !== undefined &&
          this.getSurAgt[0].secondaryValue.data.address1 !== null &&
          this.getSurAgt[0].secondaryValue.data.address1 !== ''
        ) {
          surAgtInfo = surAgtInfo + '\n' + this.getSurAgt[0].secondaryValue.data.address1
        }
        if (
          this.getSurAgt[0].secondaryValue.data.address2 !== undefined &&
          this.getSurAgt[0].secondaryValue.data.address2 !== null &&
          this.getSurAgt[0].secondaryValue.data.address2 !== ''
        ) {
          surAgtInfo = surAgtInfo + ', ' + this.getSurAgt[0].secondaryValue.data.address2
        }
        if (
          this.getSurAgt[0].secondaryValue.data.address3 !== undefined &&
          this.getSurAgt[0].secondaryValue.data.address3 !== null &&
          this.getSurAgt[0].secondaryValue.data.address3 !== ''
        ) {
          surAgtInfo = surAgtInfo + ', ' + this.getSurAgt[0].secondaryValue.data.address3
        }
        if (
          this.getSurAgt[0].secondaryValue.data.address4 !== undefined &&
          this.getSurAgt[0].secondaryValue.data.address4 !== null &&
          this.getSurAgt[0].secondaryValue.data.address4 !== ''
        ) {
          surAgtInfo = surAgtInfo + ', ' + this.getSurAgt[0].secondaryValue.data.address4
        }
        if (
          this.getSurAgt[0].secondaryValue.data.postalCode !== undefined &&
          this.getSurAgt[0].secondaryValue.data.postalCode !== null &&
          this.getSurAgt[0].secondaryValue.data.postalCode !== ''
        ) {
          surAgtInfo = surAgtInfo + ' ' + this.getSurAgt[0].secondaryValue.data.postalCode
        }
        this.surAgtDet = surAgtInfo
      } else {
        this.surAgtDet = ''
      }
    },
    parseStrformat(strvalue) {
      if (strvalue.toString().length < 2) {
        strvalue = '0' + strvalue
        return strvalue
      } else {
        return strvalue
      }
    },
    doSetAgt() {
      if (this.getSetAgt.length > 0) {
        var setAgtInfo = this.getSetAgt[0].secondaryValue.data.name
        if (
          this.getSetAgt[0].secondaryValue.data.address1 !== undefined &&
          this.getSetAgt[0].secondaryValue.data.address1 !== null &&
          this.getSetAgt[0].secondaryValue.data.address1 !== ''
        ) {
          setAgtInfo = setAgtInfo + '\n' + this.getSetAgt[0].secondaryValue.data.address1
        }
        if (
          this.getSetAgt[0].secondaryValue.data.address2 !== undefined &&
          this.getSetAgt[0].secondaryValue.data.address2 !== null &&
          this.getSetAgt[0].secondaryValue.data.address2 !== ''
        ) {
          setAgtInfo = setAgtInfo + ', ' + this.getSetAgt[0].secondaryValue.data.address2
        }
        if (
          this.getSetAgt[0].secondaryValue.data.address3 !== undefined &&
          this.getSetAgt[0].secondaryValue.data.address3 !== null &&
          this.getSetAgt[0].secondaryValue.data.address3 !== ''
        ) {
          setAgtInfo = setAgtInfo + ', ' + this.getSetAgt[0].secondaryValue.data.address3
        }
        if (
          this.getSetAgt[0].secondaryValue.data.address4 !== undefined &&
          this.getSetAgt[0].secondaryValue.data.address4 !== null &&
          this.getSetAgt[0].secondaryValue.data.address4 !== ''
        ) {
          setAgtInfo = setAgtInfo + ', ' + this.getSetAgt[0].secondaryValue.data.address4
        }
        if (
          this.getSetAgt[0].secondaryValue.data.postalCode !== undefined &&
          this.getSetAgt[0].secondaryValue.data.postalCode !== null &&
          this.getSetAgt[0].secondaryValue.data.postalCode !== ''
        ) {
          setAgtInfo = setAgtInfo + ' ' + this.getSetAgt[0].secondaryValue.data.postalCode
        }
        this.setAgtDet = setAgtInfo
      } else {
        this.setAgtDet = ''
      }
    },
    async doPolCargoRiskSave() {
      try {
        if (isEqual(this.mainForm, this.copymainForm) === true) {
          return true
        } else {
          const result = await this.$store.dispatch('savePolCargoRisk', this.mainForm)
          if (result) {
            // No need to call
            // this.getPolicyList()
            // this.doPolMasterSave()
            return true
          } else {
            return false
          }
        }
      } catch (err) {
        return false
      }
    },
    async getPolicyList() {
      this.generalForm.polNo = this.polMaster.polNo
      this.generalForm.renCnt = this.polMaster.renCnt
      this.generalForm.endtCnt = this.polMaster.endtCnt
      this.generalForm.tranDate = this.polMaster.tranDate
      this.generalForm.acceptDate = this.polMaster.acceptDate
      this.generalForm.acceptTime = this.polMaster.acceptTime
      this.generalForm.acct1DocNo = this.polMaster.acct1DocNo
      this.generalForm.acct1TranType1 = this.polMaster.acct1TranType1
      this.generalForm.acct2DocNo = this.polMaster.acct2DocNo
      this.generalForm.acct2TranType1 = this.polMaster.acct2TranType1
      this.generalForm.acct3DocNo = this.polMaster.acct3DocNo
      this.generalForm.acct3TranType1 = this.polMaster.acct3TranType1
      this.generalForm.acctNo1 = this.polMaster.acctNo1
      this.generalForm.acctNo2 = this.polMaster.acctNo2
      this.generalForm.acctNo3 = this.polMaster.acctNo3
      this.generalForm.agent = this.polMaster.agent
      this.generalForm.acctYr = this.polMaster.acctYr
      this.generalForm.acctMth = this.polMaster.acctMth
      this.generalForm.appCoIns = this.polMaster.appCoIns
      this.generalForm.billCoIns = this.polMaster.billCoIns
      this.generalForm.coInsPct = this.polMaster.coInsPct
      this.generalForm.appRiskTax = this.polMaster.appRiskTax
      this.generalForm.appShortTerm = this.polMaster.appShortTerm
      this.generalForm.batchRel = this.polMaster.batchRel
      this.generalForm.billCurr = this.polMaster.undefined
      this.generalForm.billCurrRate = this.polMaster.billCurrRate
      this.generalForm.branch = this.$store.state.token.userBranch
      this.generalForm.busSrc = this.polMaster.busSrc
      this.generalForm.cedAnt = this.polMaster.cedAnt
      this.generalForm.acctNoSfx = this.polMaster.acctNoSfx
      this.generalForm.cedPolNo = this.polMaster.cedPolNo
      this.generalForm.cedCesNo = this.polMaster.cedCesNo
      this.generalForm.cedSI = this.polMaster.cedSI
      this.generalForm.ourSharePct = this.polMaster.ourSharePct
      this.generalForm.cnType = this.polMaster.ourSharePct
      this.generalForm.cnNo = this.polMaster.cnNo
      this.generalForm.cnDate = this.polMaster.cnDate
      this.generalForm.comDate = this.polMaster.comDate
      this.generalForm.comm1 = this.polMaster.comm1
      this.generalForm.comm2 = this.polMaster.comm2
      this.generalForm.comm3 = this.polMaster.comm3
      this.generalForm.cty = this.polMaster.cty
      this.generalForm.dept = this.polMaster.dept
      this.generalForm.disc = this.polMaster.disc
      this.generalForm.dRi = this.polMaster.dri
      this.generalForm.endtDate = this.polMaster.endtDate
      this.generalForm.endtSeqNo = this.polMaster.endtSeqNo
      this.generalForm.entDate = this.polMaster.entDate
      this.generalForm.entUsrId = this.polMaster.entUsrId
      this.generalForm.expDate = this.polMaster.expDate
      this.generalForm.finInst = this.polMaster.finInst
      this.generalForm.firstIssDate = this.polMaster.firstIssDate
      this.generalForm.fund = this.polMaster.fund
      this.generalForm.genPolNo = this.polMaster.genPolNo
      this.generalForm.gstStatPrem = this.polMaster.gstStatPrem
      this.generalForm.gstStatComm1 = this.polMaster.gstStatComm1
      this.generalForm.gstStatComm2 = this.polMaster.gstStatComm2
      this.generalForm.gstStatComm3 = this.polMaster.gstStatComm3
      this.generalForm.gstRatePrem = this.polMaster.gstRatePrem
      this.generalForm.gstRateComm1 = this.polMaster.gstRateComm1
      this.generalForm.gstRateComm2 = this.polMaster.gstRateComm2
      this.generalForm.gstRateComm3 = this.polMaster.gstRateComm3
      this.generalForm.gstAEPrem = this.polMaster.gstAEPrem
      this.generalForm.gstAEComm1 = this.polMaster.gstAEComm1
      this.generalForm.gstAEComm2 = this.polMaster.gstAEComm2
      this.generalForm.gstAEComm3 = this.polMaster.gstAEComm3
      this.generalForm.gstPrem = this.polMaster.gstPrem
      this.generalForm.gstComm1 = this.polMaster.gstComm1
      this.generalForm.gstComm2 = this.polMaster.gstComm2
      this.generalForm.gstComm3 = this.polMaster.gstComm3
      this.generalForm.gstStatRateAEPrem = this.polMaster.gstStatRateAEPrem
      this.generalForm.gstStatRateAEComm1 = this.polMaster.gstStatRateAEComm1
      this.generalForm.gstStatRateAEComm2 = this.polMaster.gstStatRateAEComm2
      this.generalForm.gstStatRateAEComm3 = this.polMaster.gstStatRateAEComm3
      this.generalForm.issDate = this.polMaster.issDate
      this.generalForm.noCIPrt = this.polMaster.noCIPrt
      this.generalForm.noDrCrPrt = this.polMaster.noDrCrPrt
      this.generalForm.noTaxInvPrt = this.polMaster.noTaxInvPrt
      this.generalForm.noRiApplnPrt = this.polMaster.noRiApplnPrt
      this.generalForm.noSchedPrt = this.polMaster.noSchedPrt
      this.generalForm.occupation = this.polMaster.occupation
      this.generalForm.moCmpNo = this.polMaster.moCmpNo
      this.generalForm.paytMeth = this.polMaster.paytMeth
      this.generalForm.polEndtTxt = this.polMaster.polEndtTxt
      this.generalForm.polFee = this.polMaster.polFee
      this.generalForm.polLwrTxt = this.polMaster.polLwrTxt
      this.generalForm.polMemo = this.polMaster.polMemo
      this.generalForm.polPd = this.polMaster.polPd
      this.generalForm.polGap = this.polMaster.polGap
      this.generalForm.polRenTxt = this.polMaster.polRenTxt
      this.generalForm.polStamp = this.polMaster.polStamp
      this.generalForm.polStat = this.polMaster.polStat
      this.generalForm.polTax = this.polMaster.polTax
      this.generalForm.polType = this.polMaster.polType
      this.generalForm.polUppTxt = this.polMaster.polUppTxt
      this.generalForm.prevInsr = this.polMaster.prevInsr
      this.generalForm.progId = this.polMaster.progId
      this.generalForm.prtCILn = this.polMaster.prtCILn
      this.generalForm.prtDrCrLn = this.polMaster.prtDrCrLn
      this.generalForm.prtRiApplnLn = this.polMaster.prtRiApplnLn
      this.generalForm.prtSchedLn = this.polMaster.prtSchedLn
      this.generalForm.rcptNo = this.polMaster.rcptNo
      this.generalForm.recip = this.polMaster.recip
      this.generalForm.redBal1 = this.polMaster.redBal1
      this.generalForm.redBal2 = this.polMaster.redBal2
      this.generalForm.redBal3 = this.polMaster.redBal3
      this.generalForm.relDate = this.polMaster.relDate
      this.generalForm.relUsrId = this.polMaster.datarelUsrId
      this.generalForm.renPolNo = this.polMaster.renPolNo
      this.generalForm.riskFee = this.polMaster.riskFee
      this.generalForm.riskStamp = this.polMaster.riskStamp
      this.generalForm.riskTax = this.polMaster.riskTax
      this.generalForm.prevPolNo = this.polMaster.prevPolNo
      this.generalForm.prevPolExpDate = this.polMaster.prevPolExpDate
      this.generalForm.renSeqNo = this.polMaster.renSeqNo
      this.generalForm.retroDate = this.polMaster.retroDate
      this.generalForm.riFac = this.polMaster.riFac
      this.generalForm.schedForm = this.polMaster.schedForm
      this.generalForm.schedPremHead = this.polMaster.schedPremHead
      this.generalForm.scheme = this.polMaster.scheme
      this.generalForm.promotion = this.polMaster.promotion
      this.generalForm.securGrp = this.polMaster.securGrp
      this.generalForm.termDate = this.polMaster.termDate
      this.generalForm.totNoInstal = this.polMaster.totNoInstal
      this.generalForm.tranRel = this.polMaster.tranRel
      this.generalForm.tranType = this.polMaster.tranType
      this.generalForm.uwYr = this.polMaster.uwYr
      this.generalForm.endtType = this.polMaster.endtType
      this.generalForm.dateRenPrt = this.polMaster.dateRenPrt
      this.generalForm.discLdg1 = this.polMaster.discLdg1
      this.generalForm.discLdg2 = this.polMaster.discLdg2
      this.generalForm.discLdg3 = this.polMaster.discLdg3
      this.generalForm.endtForm = this.polMaster.endtForm
      this.generalForm.prtDiscLdg1 = this.polMaster.prtDiscLdg1
      this.generalForm.prtDiscLdg2 = this.polMaster.prtDiscLdg2
      this.generalForm.prtDiscLdg3 = this.polMaster.prtDiscLdg3
      this.generalForm.redBalDiscLdg2 = this.polMaster.redBalDiscLdg2
      this.generalForm.redBalDiscLdg3 = this.polMaster.redBalDiscLdg3
      this.generalForm.cpId = this.polMaster.cpId
      this.generalForm.insdRefNo = this.polMaster.insdRefNo
      this.generalForm.titleName = this.polMaster.titleName
      this.generalForm.insdName1 = this.polMaster.insdName1
      this.generalForm.insdName2 = this.polMaster.insdName2
      this.generalForm.insdName3 = this.polMaster.insdName3
      this.generalForm.insdAddr1 = this.polMaster.insdAddr1
      this.generalForm.insdAddr2 = this.polMaster.insdAddr3
      this.generalForm.insdAddr3 = this.polMaster.insdAddr3
      this.generalForm.insdAddr4 = this.polMaster.insdAddr4
      this.generalForm.postCode = this.polMaster.postCode
      this.generalForm.icNo = this.polMaster.icNo
      this.generalForm.telNo1 = this.polMaster.telNo1
      this.generalForm.telNo2 = this.polMaster.telNo2
      this.generalForm.mobile = this.polMaster.mobile
      this.generalForm.fax = this.polMaster.fax
      this.generalForm.email = this.polMaster.email
      this.generalForm.drCrNo = this.polMaster.drCrNo
      this.generalForm.modDate = this.polMaster.modDate
      this.generalForm.modUsrId = this.polMaster.modUsrId
      this.generalForm.grpPol = this.polMaster.grpPol
      this.generalForm.grpNamedPol = this.polMaster.grpNamedPol
      this.generalForm.empCont = this.polMaster.empCont
      this.generalForm.depdCont = this.polMaster.depdCont
      this.generalForm.stdBenRate = this.polMaster.stdBenRate
      this.generalForm.prtSchedInsd = this.polMaster.prtSchedInsd
      this.generalForm.prtSchedBen = this.polMaster.prtSchedBen
      this.generalForm.prtSchedPrem = this.polMaster.prtSchedPrem
      this.generalForm.execIC = this.polMaster.execIC
      this.generalForm.coRiPct = this.polMaster.coRiPct
      this.generalForm.maintPer = this.polMaster.maintPer
      this.generalForm.prtInsdDr = this.polMaster.prtInsdDr
      this.generalForm.industry = this.polMaster.industry
      this.generalForm.insBondNo = this.polMaster.insBondNo
      this.generalForm.totNoWrkmen = this.polMaster.totNoWrkmen
      this.generalForm.paiExpDate = this.polMaster.paiExpDate
      this.generalForm.medPolNo = this.polMaster.medPolNo
      this.generalForm.cedAcctNoSfx = this.polMaster.cedAcctNoSfx
      this.generalForm.dliabPer = this.polMaster.dliabPer
      this.generalForm.tpBill = this.polMaster.tpBill
      this.generalForm.phCltGrp = this.polMaster.phCltGrp
      this.generalForm.isPhGstReg = this.polMaster.isPhGstReg
      this.generalForm.gstRegNo = this.polMaster.gstRegNo
      this.generalForm.gstRegDate = this.polMaster.gstRegDate
      this.generalForm.polStampAE = this.polMaster.polStampAE
      this.generalForm.polFeeAE = this.polMaster.polFeeAE
      this.generalForm.polTaxAE = this.polMaster.polTaxAE
      this.generalForm.prtSubTaxInv = this.polMaster.prtSubTaxInv
      this.generalForm.premWar = this.polMaster.premWar
      this.generalForm.convEntUsrId = this.polMaster.convEntUsrId
      this.generalForm.convRelUsrId = this.polMaster.convRelUsrId
      this.generalForm.brkSlipNo = this.polMaster.brkSlipNo
      this.generalForm.brkTranRef = this.polMaster.brkTranRef
      this.generalForm.prtVarDesc = this.polMaster.prtVarDesc
      this.generalForm.acctNo2Sfx = this.polMaster.acctNo2Sfx
      this.generalForm.acctNo3Sfx = this.polMaster.acctNo3Sfx
      this.generalForm.agentAcctNoSfx = this.polMaster.agentAcctNoSfx
      this.generalForm.discLdg1Code = this.polMaster.discLdg1Code
      this.generalForm.discLdg2Code = this.polMaster.discLdg2Code
      this.generalForm.discLdg3Code = this.polMaster.discLdg3Code
      this.generalForm.insdName4 = this.polMaster.insdName4
      this.generalForm.moCmpUpld = this.polMaster.moCmpUpld
      this.generalForm.recHash = this.polMaster.recHash
      this.generalForm.prtTaxInvLn = this.polMaster.prtTaxInvLn
      this.generalForm.nxtBillMth = this.polMaster.nxtBillMth
      this.generalForm.billType = this.polMaster.billType
      this.generalForm.contractExpDate = this.polMaster.contractExpDate
      this.generalForm.cpCode = this.polMaster.cpCode
      this.generalForm.ccaDate = this.polMaster.ccaDate
      this.generalForm.ccdDate = this.polMaster.ccdDate
      this.generalForm.insdRefNoAE = this.polMaster.insdRefNoAE
      this.generalForm.insdStat = this.polMaster.insdStat
      this.generalForm.nationality = this.polMaster.nationality
      this.generalForm.icNoROC = this.polMaster.icNoROC
      this.generalForm.altName1 = this.polMaster.altName1
      this.generalForm.altName2 = this.polMaster.altName2
      this.generalForm.sameInsdAddr = this.polMaster.sameInsdAddr
      this.generalForm.altInsdAddr1 = this.polMaster.altInsdAddr2
      this.generalForm.altInsdAddr2 = this.polMaster.altInsdAddr2
      this.generalForm.altInsdAddr3 = this.polMaster.altInsdAddr3
      this.generalForm.altInsdAddr4 = this.polMaster.altInsdAddr4
      this.generalForm.altPostCode = this.polMaster.altPostCode
      this.generalForm.agtUsrId = this.polMaster.agtUsrId
      this.generalForm.DOB = this.polMaster.dob
      this.generalForm.gender = this.polMaster.gender
      this.generalForm.normOnRel = this.polMaster.normOnRel
      this.generalForm.endtCode = this.polMaster.endtCode
      this.generalForm.cancelCode = this.polMaster.cancelCode
      this.generalForm.entRilater = this.polMaster.entRilater
      this.generalForm.ipcStatus = this.polMaster.ipcStatus
      this.generalForm.ipcNo = this.polMaster.ipcNo
      this.generalForm.ipcDate = this.polMaster.ipcDate
      this.generalForm.ourShareSI = this.polMaster.ourShareSI
      this.generalForm.campaign = this.polMaster.campaign
      this.generalForm.riApplnPrt = this.polMaster.riApplnPrt
      this.generalForm.ciPrt = this.polMaster.ciPrt
      this.generalForm.ipcSeqNo = this.polMaster.ipcSeqNo
      this.generalForm.certBord = this.mainForm.certBord
      this.generalForm.createdBy = this.polMaster.createdBy
      this.generalForm.createdDate = this.polMaster.createdDate
      this.generalForm.modifiedBy = this.polMaster.modifiedBy
      this.generalForm.modifiedDate = this.polMaster.modifiedDate
      this.generalForm.revision = this.polMaster.revision
      this.loading = false
    },
    async doPolMasterSave() {
      try {
        this.$store.commit(POLICY_GENERAL, this.generalForm)
        const saveResult = await this.$store.dispatch('savePolMaster')

        if (saveResult) {
          return true
        } else {
          return false
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.notify(data)
        }
      }
    }
  },
  beforeMount() {
    this.$validator.extend('VoyageDate_Validate', {
      getMessage(field, args) {
        return `The Month/Day of Voyage date is ealier than the Start Date`
      },
      validate(value, args) {
        if (parseInt(args[0]) < parseInt(args[1])) {
          if (parseInt(args[2]) < parseInt(args[3])) {
            return false
          }
        }
        return true
      }
    })
    this.$validator.extend('VoyageDate_Validate2', {
      getMessage(field, args) {
        return `The Year of Voyage date is Earlier than U/W Year.`
      },
      validate(value, args) {
        if (parseInt(args[0]) < parseInt(args[1])) {
          if (parseInt(args[2]) >= parseInt(args[3])) {
            return false
          }
        }
        return true
      }
    })
    if (this.$store.state.underwriting.policyCargoRiskSettings.init !== 1) {
      this.$store.dispatch('policyCargoRiskInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin],
  components: {
    VesselVoyage
  }
}
</script>

<style lang="scss">
.voyDateWarning {
  .v-messages__message {
    color: $error !important;
  }
}
</style>
